import React from "react";
import {
  FooterSection,
  AfterFooter,
  ContactSection,
  BoxContact,
  WpImage,
  WitLogo,
  TitleSection,
  ContactInfoSpan,
  BoxPages,
  BoxPagesCentered,
  SocialIcon,
  FooterContainer,
  ArroundIcon,
  StoreLogo
} from "./styles";
import { Row, Col, Container } from "react-bootstrap";
import WitSoccerWhiteLogo from "../../../assets/img/witsoccer-logo-white.png";
import WpLogo from "../../../assets/img/whatsapp.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import GooglePlay from "../../../assets/img/google-play.png";
import AppleStore from "../../../assets/img/apple-store.png";
export default function Footer() {
  return (
    <>
      <FooterSection>
        <Container>
          <Row>
            <Col md="6" lg="3" style={{paddingLeft: "o"}}>
              <BoxContact>
                <WitLogo src={WitSoccerWhiteLogo} />
                <ContactSection>
                  <TitleSection>CONTATO</TitleSection>
                  <ContactInfoSpan>contato@witsoccer.com</ContactInfoSpan>
                  <div>
                    <WpImage src={WpLogo} />
                    <ContactInfoSpan>31 99780-1310</ContactInfoSpan>
                  </div>
                </ContactSection>
              </BoxContact>
            </Col>
            <Col md="6" lg="3">
              <BoxPagesCentered>
                <TitleSection>PÁGINAS PRINCIPAIS</TitleSection>
                <a href="https://witsoccer.com/empresa/">
                  <ContactInfoSpan>Empresa</ContactInfoSpan>
                </a>
                <a href="https://witsoccer.com/termosdeservico/">
                  <ContactInfoSpan>Termos de Serviço</ContactInfoSpan>
                </a>
                <a href="https://witsoccer.com/cancelamento/">
                  <ContactInfoSpan>Política de cancelamento</ContactInfoSpan>
                </a>
                <a href="https://witsoccer.com/o-que-falam-da-wit/">
                  <ContactInfoSpan>O que falam da wit</ContactInfoSpan>
                </a>
                <a href="https://witsoccer.com/midiapress/">
                  <ContactInfoSpan>Imprensa</ContactInfoSpan>
                </a>
              </BoxPagesCentered>
            </Col>
            <Col md="6" lg="3">
              <BoxPages>
                <TitleSection>SIGA-NOS</TitleSection>
                <BoxContact>
                  <SocialIcon>
                    <ArroundIcon>
                      <a href="https://www.facebook.com/witsoccer">
                        <FontAwesomeIcon size="lg" icon={faFacebookF} />
                      </a>
                    </ArroundIcon>
                  </SocialIcon>
                  <SocialIcon>
                    <ArroundIcon>
                      <a href="https://www.instagram.com/witsoccer/">
                        <FontAwesomeIcon size="lg" icon={faInstagram} />
                      </a>
                    </ArroundIcon>
                  </SocialIcon>
                  <SocialIcon>
                    <ArroundIcon>
                      <a href="https://www.youtube.com/channel/UCXST96uKxptgTcA0xfnHqhw">
                        <FontAwesomeIcon size="lg" icon={faYoutube} />
                      </a>
                    </ArroundIcon>
                  </SocialIcon>
                </BoxContact>
              </BoxPages>
            </Col>
            <Col id="stores" md="6" lg="3">
              <BoxPagesCentered>
                <TitleSection>BAIXE O APP</TitleSection>
                <a href="https://play.google.com/store/apps/details?id=br.com.ioasys.witsoccer">
                  <StoreLogo src={GooglePlay} />
                </a>
                <a href="https://play.google.com/store/apps/details?id=br.com.ioasys.witsoccer">
                  <StoreLogo src={AppleStore} />
                </a>
              </BoxPagesCentered>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <AfterFooter>
        Copyright © 2018 Wit Soccer ®
      </AfterFooter>
    </>
  );
}
